import { Card, CardActions, CardContent, Typography } from '@mui/material';
import React, { FunctionComponent } from 'react';

import { ForcePaymentDialog } from '../../../../../event/pages/Payment/components/ForcePaymentDialog/ForcePaymentDialog';
import { PayWithHelloAssoButton } from '../../../../../event/pages/Payment/components/PayWithHelloAssoButton/PayWithHelloAssoButton';
import { useBedroomOnlinePaymentCard } from './useBedroomOnlinePaymentCard';

interface BedroomOnlinePaymentCardProps {
  bedroomValue: number;
  eventId: string;
}

export const BedroomOnlinePaymentCard: FunctionComponent<
  BedroomOnlinePaymentCardProps
> = ({ bedroomValue, eventId }) => {
  const {
    onPayWithHelloAsso,
    isForceDialogVisible,
    onCloseForcePaymentDialog,
    onForcePayment,
    currentEvent,
  } = useBedroomOnlinePaymentCard(eventId);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">{`Acheter une place en chambre`}</Typography>
        <Typography>{`Une place en chambre coûte ${bedroomValue / 100}€`}</Typography>
        {currentEvent?.isValidated ? null : (
          <Typography fontWeight="medium">{`Attention : Vous n'êtes pas encore validé. Le nombre de place en chambre est limité, mais nous vous permettons de payer tout de suite. Si entre le moment où vous payez une place et le moment où vous êtes validés la dernière place en chambre a été vendu, nous vous rembourserons.`}</Typography>
        )}
      </CardContent>
      <CardActions>
        <PayWithHelloAssoButton
          amount={bedroomValue}
          onClick={onPayWithHelloAsso}
        />
      </CardActions>
      <ForcePaymentDialog
        onCancel={onCloseForcePaymentDialog}
        onForce={onForcePayment}
        open={isForceDialogVisible}
      />
    </Card>
  );
};
